import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-3" }
const _hoisted_4 = { class: "home__info--item home__info--item-1" }
const _hoisted_5 = { class: "home__info__item--left" }
const _hoisted_6 = { class: "home__info__item--icon" }
const _hoisted_7 = { class: "home__info__item--right" }
const _hoisted_8 = { class: "home__info__item--title" }
const _hoisted_9 = { class: "home__info__item--text" }
const _hoisted_10 = { class: "col-lg-3" }
const _hoisted_11 = { class: "home__info--item home__info--item-2" }
const _hoisted_12 = { class: "home__info__item--left" }
const _hoisted_13 = { class: "home__info__item--icon" }
const _hoisted_14 = { class: "home__info__item--right" }
const _hoisted_15 = { class: "home__info__item--title" }
const _hoisted_16 = { class: "home__info__item--text" }
const _hoisted_17 = { class: "col-lg-3" }
const _hoisted_18 = { class: "home__info--item home__info--item-3" }
const _hoisted_19 = { class: "home__info__item--left" }
const _hoisted_20 = { class: "home__info__item--icon" }
const _hoisted_21 = { class: "home__info__item--right" }
const _hoisted_22 = { class: "home__info__item--title" }
const _hoisted_23 = { class: "home__info__item--text" }
const _hoisted_24 = { class: "col-lg-3" }
const _hoisted_25 = { class: "home__info--item home__info--item-4" }
const _hoisted_26 = { class: "home__info__item--left" }
const _hoisted_27 = { class: "home__info__item--icon" }
const _hoisted_28 = { class: "home__info__item--right" }
const _hoisted_29 = { class: "home__info__item--title" }
const _hoisted_30 = { class: "home__info__item--text" }
const _hoisted_31 = { class: "container" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "col-9" }, [
  /*#__PURE__*/_createVNode("div", {
    id: "chartdiv",
    class: "chartdiv"
  })
], -1)
const _hoisted_34 = { class: "col-3" }
const _hoisted_35 = { class: "admin-city-box" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Посетители в разрезе областей", -1)
const _hoisted_37 = { class: "countrycity" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_main_footer = _resolveComponent("main-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_svg_icon, { name: "user_circle" })
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.admin.online), 1),
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('adminApp.online')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_svg_icon, { name: "show" })
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.admin.viewed), 1),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('adminApp.viewed')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_svg_icon, { name: "user_check" })
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, _toDisplayString(_ctx.admin.users), 1),
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('adminApp.accounts')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_svg_icon, { name: "download" })
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, _toDisplayString(_ctx.admin.downloaded), 1),
              _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('adminApp.download')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_31, [
      _createVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode("div", _hoisted_37, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countryCity, (city) => {
                return (_openBlock(), _createBlock("div", {
                  class: "div",
                  key: city.id
                }, _toDisplayString(city.city.name_ru) + " : " + _toDisplayString(city.count), 1))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_main_footer)
  ], 64 /* STABLE_FRAGMENT */))
}